var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text",class:_vm.$mq},[_c('span',[_vm._v("Die Welt der Wagnerianer:")]),_c('br'),_vm._v(" Von Venedig über Lettland, Israel, Abu Dhabi und die USA bis nach Japan. ")])}
var staticRenderFns = []

export { render, staticRenderFns }